import { render, staticRenderFns } from "./RoomBadges.vue?vue&type=template&id=be9bb616&scoped=true&"
import script from "./RoomBadges.vue?vue&type=script&lang=js&"
export * from "./RoomBadges.vue?vue&type=script&lang=js&"
import style0 from "./RoomBadges.vue?vue&type=style&index=0&id=be9bb616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9bb616",
  null
  
)

export default component.exports